// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"197":"13b64f32","756":"d777c2c2"}[chunkId] + ".chunk.js";
};